// =============================================================================
// Configuration
// =============================================================================

// Set to true to use SECONDS instead of MINUTES for testing
export const TEST_MODE = false;

export const DEBUG_MODE = false;

export const LOG = false;

// =============================================================================
// Logging
// =============================================================================

export const log = (context: string, message: string, data?: unknown): void => {
  if (!LOG) return;
  const timestamp = new Date().toISOString().split('T')[1].slice(0, 12);
  console.log(`[${context} ${timestamp}] ${message}`, data !== undefined ? data : '');
};

export const TIME_UNIT = TEST_MODE ? 1000 : 60 * 1000; // 1 second or 1 minute

export const INACTIVITY_LOGOUT_TIME = 60 * TIME_UNIT; // 60 minutes/seconds
export const ACTIVITY_CHECK_INTERVAL = 1 * TIME_UNIT; // Check every 1 minute/second
export const WARNING_THRESHOLDS = [30, 15, 5]; // Show warnings at these remaining times

export const TOKEN_REFRESH_BUFFER = 60 * 1000 * 1; // Refresh 1 minute before expiry
export const TOKEN_CHECK_INTERVAL = 10 * 1000; // Check token every 10 seconds

export const ACTIVITY_EVENTS = ['mousedown', 'keydown', 'scroll', 'touchstart', 'click'];

// =============================================================================
// Types
// =============================================================================

export interface TokenInfo {
  accessExp: number | null;
  idExp: number | null;
}

export interface RefreshEvent {
  time: number;
  oldExp: number;
  newExp: number;
}

export interface SessionState {
  isAuthenticated: boolean;
  isLoading: boolean;
  tokenInfo: TokenInfo;
  lastActivity: number;
  refreshCount: number;
  lastRefresh: RefreshEvent | null;
  refreshLog: RefreshEvent[];
  error: string | null;
}
